module.exports = __webpack_public_path__ + "img/1f9ad.42f2537.svg";